module.exports = __webpack_public_path__ + "img/PC_01.86fd895b.jpg";